import { render, staticRenderFns } from "./partyList.vue?vue&type=template&id=63b1ef4b&scoped=true"
import script from "./partyList.vue?vue&type=script&lang=js"
export * from "./partyList.vue?vue&type=script&lang=js"
import style0 from "./partyList.vue?vue&type=style&index=0&id=63b1ef4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b1ef4b",
  null
  
)

export default component.exports